import React from "react"
import { useDispatch, useSelector } from "react-redux"

import TablePagination from "../../../../components/TablePagination"
import { getProductTypesFiltersSelector, getProductTypesTotalSelector } from "../../../../reducers/ProductTypes/productTypes"
import { DEFAULT_ROW_PER_PAGE_OPTIONS } from "../../../../utils/constant"

const ProductTypesPagination = () => {
    const dispatch = useDispatch()
    const filters = useSelector(getProductTypesFiltersSelector)
    const total = useSelector(getProductTypesTotalSelector)

    const handleIncrementPage = () => {
        dispatch({
            type: "PRODUCT_TYPES_FILTERS_LOADED",
            filters: { ...filters, page: filters.page + 1 }
        })
    }

    const handleDecrementPage = () => {
        dispatch({
            type: "PRODUCT_TYPES_FILTERS_LOADED",
            filters: { ...filters, page: filters.page - 1 }
        })
    }

    const handleChangeRowsPerPage = value => {
        dispatch({
            type: "PRODUCT_TYPES_FILTERS_LOADED",
            filters: { ...filters, rowsPerPage: parseInt(value, 10), page: 0 }
        })
    }

    return (
        <TablePagination
            component="div"
            choices={DEFAULT_ROW_PER_PAGE_OPTIONS}
            total={total}
            rowsPerPage={filters.rowsPerPage}
            dataPage={filters.page}
            incrementPage={handleIncrementPage}
            decrementPage={handleDecrementPage}
            handleChangeRowPerPage={handleChangeRowsPerPage}
            labelRowsPerPage="Types de produits par page"
        />
    )
}

export default ProductTypesPagination